<template>
	<!-- 企业管理 -->
	<section>
		<!--工具条-->
		<el-col  v-if="bquery" :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					<el-input v-model="filters.companyName" placeholder="企业名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getCompanyList">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button  type="success" @click="handleAdd">新增企业</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="warning" @click="handledc" :loading="dcLoading">导出</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="companylist" highlight-current-row v-loading="listLoading"  style="width: 100%;">
			<el-table-column prop="coName" label="企业名称" min-width="200" align="center">
			</el-table-column>
			<el-table-column  v-if="!cityFix&&bquery" prop="cityName" label="所属城市" min-width="100" align="center">
			</el-table-column>
			<el-table-column prop="districtName" label="所属区" align="center"  min-width="100">
			</el-table-column>
			<el-table-column prop="kdppTypeName" label="品牌" align="center"  min-width="100">
			</el-table-column>
			<el-table-column prop="coHeadName" label="法人或负责人姓名" align="center" min-width="150">
			</el-table-column>
			<el-table-column prop="coHeadMobile" label="法人或负责人电话" align="center"  min-width="150">
			</el-table-column>

			<el-table-column   label="操作" align="left" width="300">
				<template slot-scope="scope">
					<el-button  v-if="bquery" type="success" size="small" @click="showGuestcompany(scope.$index, scope.row)">协议客户</el-button>
					<el-button  type="info" size="small" @click="handleDetail(scope.$index, scope.row)">详情</el-button>
          			<el-button  v-if="bshow" type="success" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button  v-if="bquery" type="danger" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total,prev, pager, next" @current-change="handleCurrentChange" :page-size="20" :total="total" style="float:right;">
			</el-pagination>
		</el-col>

		<!--新增企业信息-->
		<el-dialog title="新增企业信息" v-model="addFormVisible" :close-on-click-modal="false">
			<el-form :model="addForm" label-width="120px" :rules="addFormRules" ref="addForm">
				<el-row>
					<el-col :span="24">
						<el-form-item label="企业名称" prop="coName">
							<el-input v-model="addForm.coName" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11"> 
						<el-form-item label="法人或负责人姓名" prop="coHeadName">
							<el-input v-model="addForm.coHeadName" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">      
						<el-form-item label="法人或负责人身份证号" prop="coHeadWidNo">
							<el-input v-model="addForm.coHeadWidNo" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="11">
						<el-form-item label="法人或负责人电话" prop="coHeadMobile">
							<el-input v-model="addForm.coHeadMobile" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
		
					<el-col :span="11" :offset="2">      
						<el-form-item label="企业联系邮箱" prop="coEmail">
							<el-input v-model="addForm.coEmail" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="11">
						<el-form-item label="经营许可证号或分支机构名录号" prop="businessNumber">
							<el-input v-model="addForm.businessNumber" auto-complete="off"></el-input>
							</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">      
						<el-form-item label="许可证有效期止" prop="businessNumberEffectDate">
							<el-date-picker v-model="addForm.selBusinessNumberEffectDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-form-item label="社会信用代码" prop="socialCreditCode">
						<el-input v-model="addForm.socialCreditCode" auto-complete="off"></el-input>
					</el-form-item>
				</el-row>
				<el-row>
					<el-form-item label="企业地址" prop="coAddress">
						<el-input v-model="addForm.coAddress" auto-complete="off"></el-input>
					</el-form-item>
				</el-row>
				<!-- <el-row>
					<el-form-item label="企业简介" prop="coDesc">
					<el-input v-model="addForm.coDesc" auto-complete="off"></el-input>
					</el-form-item>
				</el-row> -->

				<!-- 选择品牌，区信息 -->
			 	<el-row>
					<el-col :span="11" >      
						<el-form-item label="品牌" >
							<el-select v-model="ppvalue" placeholder="请选择" >
								<el-option v-for="item in ppoptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">  
						<el-form-item label="区" >
							<el-select v-model="dvalue" placeholder="请选择">
								<el-option v-for="item in doptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 选择省，市 -->
				<el-row>
					<el-col :span="11">
						<el-form-item label="省" >
							<el-select v-model="pvalue"  @change="ssbmpchange"  placeholder="请选择" :disabled="true">
								<el-option v-for="item in poptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">  
						<el-form-item label="市" >
							<el-select v-model="cvalue"  @change="ssbmcchange"  placeholder="请选择" :disabled="cityFix">
								<el-option v-for="item in coptions" :key="item.Mpid" :label="item.MpCn" :value="item.MpValue"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="addFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="addCompany" :loading="addLoading">保存</el-button>
			</div>
		</el-dialog>


		<!--编辑企业信息，企业名字，所属城市不能修改-->
		<el-dialog :title="editFormTitle" v-model="editFormVisible" :close-on-click-modal="false">
      		<el-form :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">	
				<el-row>
					<el-col :span="11">
						<el-form-item label="法人或负责人电话" prop="coHeadMobile">
							<el-input v-model="editForm.coHeadMobile" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
		
					<el-col :span="11" :offset="2">      
						<el-form-item label="企业联系邮箱" prop="coEmail">
							<el-input v-model="editForm.coEmail" auto-complete="off"></el-input>
						</el-form-item>
					</el-col>
				</el-row>

				<el-row>
					<el-col :span="11">
						<el-form-item label="经营许可证号或分支机构名录号" prop="businessNumber">
							<el-input v-model="editForm.businessNumber" auto-complete="off"></el-input>
							</el-form-item>
					</el-col>
					<el-col :span="11" :offset="2">      
						<el-form-item label="许可证有效期止" prop="businessNumberEffectDate">
							<el-date-picker v-model="editForm.selBusinessNumberEffectDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"></el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>

        		<el-form-item label="企业地址" prop="coAddress">
					<el-input v-model="editForm.coAddress" auto-complete="off"></el-input>
				</el-form-item>

				<!-- <el-form-item label="企业简介" prop="coDesc">
					<el-input v-model="editForm.coDesc" auto-complete="off"></el-input>
				</el-form-item> -->
      		</el-form>
      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">关闭</el-button>
				<el-button type="primary" @click.native="updateInfo" :loading="editLoading">保存</el-button>
			</div>
		</el-dialog>

		<el-dialog title="企业详情" v-model="detailFormVisible" :close-on-click-modal="false">
      		<!-- 企业其他信息 -->
			<h2 class="base-name">{{ detailForm.coName }}</h2>
			<div class="base-info-row">
				<div class="info-item">
					<span class="label">法人或负责人姓名：</span>
					<span class="value">{{detailForm.coHeadName}}</span>
				</div>
				<div class="info-item">
					<span class="label">法人或负责人电话：</span>
					<span class="value">{{detailForm.coHeadMobile}}</span>
				</div>
				<div class="info-item">
					<span class="label">法人或负责人身份证号：</span>  
					<span class="value">{{detailForm.coHeadWidNo}}</span>
				</div>
				<div class="info-item">
					<span class="label">社会信用代码：</span>
					<span class="value">{{detailForm.socialCreditCode}}</span>
				</div>
				<div class="info-item">
					<span class="label">企业联系邮箱：</span>
					<span class="value">{{detailForm.coEmail}}</span>
				</div>
				  
				<div class="info-item">
					<span class="label">经营许可证号或分支机构名录号：</span>
					<span class="value">{{detailForm.businessNumber}}</span>
				</div>

				<!-- 过期显示红色 -->
				<div class="info-item" v-if='new Date(detailForm.businessNumberEffectDate)<new Date()'>
					<span class="label">许可证有效期止：</span>
					<span style="color: red;">{{detailForm.businessNumberEffectDate}}</span>
				</div>
					
				<div class="info-item" v-else>
					<span class="label">许可证有效期止：</span>
					<span style="color: #333;">{{detailForm.businessNumberEffectDate}}</span>
				</div>

				<div class="info-item">
					<span class="label">企业地址：</span>
					<span class="value">{{detailForm.coAddress}}</span>
				</div>
			</div>

      
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="detailFormVisible = false">关闭</el-button>
			</div>
		</el-dialog>

		<!--显示企业协议客户表-->
		<el-dialog title="企业协议客户" v-model="guestcomVisible" :close-on-click-modal="false">
      		<!--工具条-->
			<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
				<el-form :inline="true" :model="gfilters">
					<el-form-item>
						<el-input v-model="gfilters.guestComName" placeholder="客户名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" v-on:click="guestCompanyList">查询</el-button>
					</el-form-item>
					
				</el-form>
			</el-col>

			<!--列表 fileUrl,fileName-->
			<el-table :data="comguestlist" highlight-current-row  style="width: 100%;">
				<el-table-column prop="guestComName" label="客户名称" min-width="140" align="center">
				</el-table-column>
				<el-table-column prop="guestName" label="法人或寄件人姓名" align="center"  min-width="120">
				</el-table-column>
				<el-table-column prop="guestPhone" label="法人或寄件人电话" align="center"  min-width="120">
				</el-table-column>
				<el-table-column  prop="guestWid" label="法人或寄件人身份证号" align="center"  min-width="150">
		 		</el-table-column>
				<el-table-column prop="guestDate" label="协议签订日期"  align="center" min-width="120">
				</el-table-column>
				<el-table-column prop="guestGoods" label="物品名称"  align="center" min-width="100">
				</el-table-column>

				<el-table-column   label="操作"  align="left" width="200">
					<template slot-scope="scope">
						<el-button type="primary" size="small" @click="handleFileShow(scope.$index, scope.row)">查看协议</el-button>
						<el-button type="primary" size="small" @click="handleWidNoShow(scope.$index, scope.row)">查看证件</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!--工具条-->
			<el-col :span="24" class="toolbar">
				<el-pagination layout="total,prev, pager, next" @current-change="handlegCurrentChange" :page-size="20" :total="gtotal" style="float:right;">
				</el-pagination>
			</el-col>

			<div slot="footer" class="dialog-footer">
				<el-button @click.native="guestcomVisible = false">关闭</el-button>	
			</div>
		</el-dialog>

			<!--显示PDF-->
		<el-dialog :title="pdfFileName" v-model="pdfVisible" :close-on-click-modal="false" >
			<el-form>
				<iframe :src="pdfSrc" frameborder="0" style="width: 100%; height: 500px"></iframe>
			</el-form>
		</el-dialog>

	</section>
</template>

<script>
	import { companyPageList,companyPageListdc,addCompany,editCompany,deleteCompany,getparamsByType,companyGuestPageList} from '../../api/api';

	let moment = require("moment");
	export default {
		data() {
			return {
				objectId:0, //当前登录的用户id，新增会用到
				bquery:false,//管理员权限
				bshow:false,//是否显示操作按钮

				filters: {
					companyName: ''
				},
				companylist: [],
				total: 0,
				page: 1,
				listLoading: false,

				//新增企业信息
				addFormVisible: false, 
				addLoading: false,
				addFormRules: {
					coName: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
					coHeadName: [{ required: true, message: "请输入法人或负责人姓名", trigger: "blur" }],
					coHeadWidNo: [{ required: true, message: "请输入法人或负责人身份证号", trigger: "blur" }],
					coHeadMobile: [{ required: true, message: "请输入法人或负责人电话", trigger: "blur" }]
				},
				
				addForm: {
					createUserId:"",
					cityCode:'',
					province:'',

					districtCode:'',
					kdppType:'',

					coName: "",
					coHeadName: "",
					coHeadWidNo:"",
					coHeadMobile: "",
					socialCreditCode:"",
					coAddress:"",
					businessNumber:"", 
					coEmail:"",
					coDesc:"",
					businessNumberEffectDate:"",				
					selBusinessNumberEffectDate:null,
				},

				//编辑企业信息
				editFormTitle:'',  //编辑的时候，显示企业名称
				editFormVisible: false, 
				editLoading: false,
				editFormRules: {

					coHeadMobile: [{ required: true, message: "请输入法人或负责人电话", trigger: "blur" }]
				},
				
				editForm: {
					coHeadMobile: "",
					coEmail:"",
					businessNumber:"", 
          			businessNumberEffectDate:"",
					selBusinessNumberEffectDate:null,	

					coAddress:"",
					coDesc:"",
					
					coId:0,
				},

				poptions: [],
				pvalue:'',
				pvalueid:'',

				coptions: [],
				cvalue:'',
				cvalueid:'',
				cityFix:true,

				//企业详情页面
				detailFormTitle:'',  //编辑的时候，显示企业名称
				detailFormVisible: false, 
				
				detailForm: {	
					coName:'',
					coHeadName:'',
					coHeadMobile:'',
					coHeadWidNo:'',
					socialCreditCode:'',
					coEmail:'',
					businessNumber:'',
					businessNumberEffectDate:'',
					coAddress:'',
					coDesc:''
				},

				//品牌选择
				ppoptions: [],
				ppvalue:'',
				//所在区选择
				doptions: [],
				dvalue:'',

				comguestlist: [],
				gtotal: 0,
				gpage: 1,
				curcoId:0,
				guestcomVisible:false,

				gfilters: {
					guestComName: '',
				},

				// 显示pdf
				pdfVisible: false, 
				pdfSrc: '', // 将从后台获取到的 PDF 文件地址赋值给这个字段
				pdfFileName:"",
				// 正式地址
				filebaseurl:"https://aqjg.ycsyzglj.com/",

				//要导出的数据list
				exportList: [],
				dcLoading: false
				//end
			}
		},
		methods: {
			
			handleCurrentChange(val) {				
				this.page = val;
				this.getCompanyList();
			},
			//获取用户列表
			getCompanyList() {
				let para = {
					page: this.page,
					pageSize:20,
					objectId:this.objectId,
					coName: this.filters.companyName,
				};

				this.listLoading = true;

				companyPageList(para).then((res) => {

					if(res.data.code==0){
						this.total = res.data.data.total;
						this.companylist = res.data.data.list;
					}
					
					this.listLoading = false;

				});
			},
			isValidIdCard(idCard) {
				const regex = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[\dXx]$/;
				if (!regex.test(idCard)) {
					return false;
				}
				const coefficient = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
				const checkCode = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'];
				let sum = 0;
				for (let i = 0; i < 17; i++) {
					sum += parseInt(idCard[i], 10) * coefficient[i];
				}
				const mod = sum % 11;
				const lastChar = idCard[17].toUpperCase(); // 将最后一位转为大写，以支持大小写混合的X
				return checkCode[mod] === lastChar;
			},

			isValidatePhone(phonenumber){
				// 手机号正则表达式
				const regphone = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
				// 验证手机号
				if (!regphone.test(phonenumber)) {
					return false
				} else {
					return true
				}
			},
			isValidateEmail(email){
				// 邮箱地址email正则表达式
				const regEmail = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/

				// 验证手机号
				if (!regEmail.test(email)) {
					return false
				} else {
					return true
				}
			},
			//管理员新增企业信息
			handleAdd: function () {
				this.addFormVisible = true;

				//二级选项
				this.addForm.province=this.pvalue
				this.addForm.cityCode=this.cvalue
				this.addForm.createUserId=this.objectId

				this.addForm.districtCode=this.dvalue
				this.addForm.kdppType=this.ppvalue

				this.addForm.coName= ""
				this.addForm.coHeadName= ""
				this.addForm.coHeadWidNo=""
				this.addForm.coHeadMobile= ""
				this.addForm.socialCreditCode=""
				this.addForm.coAddress=""
				this.addForm.businessNumber="" 
				this.addForm.coEmail=""
				this.addForm.coDesc=""
				this.addForm.businessNumberEffectDate=""				
				this.addForm.selBusinessNumberEffectDate=null
			},
			addCompany: function () {
				//对于输入邮箱合法性进行判断
				if (this.addForm.coEmail!="") {
					if (this.isValidateEmail(this.addForm.coEmail)) {
						this.addCompanyReq()
					}
					else{
						this.$message.error("请输入有效的邮箱");	
					} 
				}
				else{
					this.addCompanyReq()
				}
			},
			addCompanyReq() {
				if (this.cvalue=='') {
					this.$message.error("请选择企业所在的城市");
				}else if (this.dvalue=='') {
					this.$message.error("请选择企业所在的区");
				}else {
					//二级选项
					this.addForm.province=this.pvalue
					this.addForm.cityCode=this.cvalue
					this.addForm.districtCode=this.dvalue
					
					this.addForm.kdppType=this.ppvalue
					
					if(this.addForm.selBusinessNumberEffectDate!=null){
						this.addForm.businessNumberEffectDate = this.addForm.selBusinessNumberEffectDate.toLocaleString();
					}

					this.$refs.addForm.validate((valid) => {
						if (valid) {
							//对于输入电话，身份证号合法性进行判断
							if (!this.isValidIdCard(this.addForm.coHeadWidNo)) {
								this.$message.error("请输入有效的身份证号");	
							} else if (!this.isValidatePhone(this.addForm.coHeadMobile)) {
								this.$message.error("请输入有效的手机号");
							} else {
								this.$confirm('确认添加企业信息吗？', '提示', {}).then(() => {
								this.addLoading = true;

								addCompany(this.addForm).then((res) => {
									this.addLoading = false;
									this.addFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
										this.getCompanyList();
									}
									else{
										this.$message.error(res.data.message);
									}
						

									});
								});
							}		
						}
					});
				}
			},
			handleEdit: function (index, row) {
				this.editFormVisible = true;

				this.editFormTitle = row.coName
				
				this.editForm={
					coHeadMobile: row.coHeadMobile,
				  	coEmail:row.coEmail,

					businessNumber:row.businessNumber,
					businessNumberEffectDate:"",     
					selBusinessNumberEffectDate:row.businessNumberEffectDate,
      
					coAddress:row.coAddress,
					coDesc:row.coDesc,
					coId:row.coId
				}
			},
			updateInfo: function () {
				//对于输入邮箱合法性进行判断
				if (this.editForm.coEmail!="") {
					if (this.isValidateEmail(this.editForm.coEmail)) {
						this.updateCompanyInfo()
					}
					else{
						this.$message.error("请输入有效的邮箱");	
					} 
				}
				else{
					this.updateCompanyInfo()
				}

			},
			updateCompanyInfo () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						if (!this.isValidatePhone(this.editForm.coHeadMobile)) {
							this.$message.error("请输入有效的手机号");
						} else {
							this.$confirm('确认更新企业信息吗？', '提示', {}).then(() => {
							this.editLoading = true;

							if(this.editForm.selBusinessNumberEffectDate!=null){
								this.editForm.businessNumberEffectDate = this.editForm.selBusinessNumberEffectDate.toLocaleString();
							}
		
							editCompany(this.editForm).then((res) => {
									this.editLoading = false;
									this.editFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);

										this.getCompanyList();
									}
									else{
										this.$message.error(res.data.message);
									}
								});
							});
						}
					}
				});
			},	
			handleDetail: function (index, row) {
				this.detailFormVisible = true;

				this.detailForm.coName= row.coName

				this.detailForm.coHeadName= row.coHeadName 
				this.detailForm.coHeadMobile= row.coHeadMobile
				this.detailForm.coHeadWidNo= row.coHeadWidNo

				this.detailForm.socialCreditCode= row.socialCreditCode
				this.detailForm.coEmail=row.coEmail,
				this.detailForm.businessNumber=row.businessNumber,
				this.detailForm.businessNumberEffectDate=row.businessNumberEffectDate
				this.detailForm.coAddress=row.coAddress
				this.detailForm.coDesc=row.coDesc				
			},
			
			handleDelete: function (index, row) {

				this.$confirm('确认删除这个企业吗？', '提示', {}).then(() => {

					let deletecompanyparam={
						coId:row.coId,
					}

					deleteCompany(deletecompanyparam).then((res) => {
						if(res.data.code==0){
						this.$message.success(res.data.message);
						this.getCompanyList();
						}
						else{
						this.$message.error(res.data.message);
						}
					});
				}).catch(() => {
  					// 用户点了取消 → 必须写 catch，否则控制台报错
					// this.$message.info('已取消');
				});	
			},	

			ssbmpchange(e) {
				for (let index = 0; index < this.poptions.length; index++) {
					const element = this.poptions[index];
					if (element.MpValue==e) {
						this.pvalueid=element.Mpid
						this.pvalue=element.MpValue
						this.getcitiesbyprovince()
						break;
					}
				}
			},
			ssbmcchange(e) {
				for (let index = 0; index < this.coptions.length; index++) {
					const element = this.coptions[index];
					if (element.MpValue==e) {
						this.cvalueid=element.Mpid
						this.cvalue=element.MpValue
						this.getdistrictbycity()
						break;
					}
				}
			},
			//省信息
			getprovinces() {
				let para={
					MpType:"SSCC",
					MpParentId:"0"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.poptions  =res.data.data
						this.pvalueid=this.poptions[0].Mpid
						this.pvalue=this.poptions[0].MpValue
						this.getcitiesbyprovince()
					}
				});
			},
			getcitiesbyprovince() {
				let para={
					MpType:"SSCC",
					MpParentId:this.pvalueid
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.coptions  =res.data.data
						if(this.cvalue==''){
							this.cvalue=this.coptions[0].MpValue
							this.cvalueid=this.coptions[0].Mpid
						}
						else{
							for (let index = 0; index < this.coptions.length; index++) {
								const element = this.coptions[index];
								if(element.MpValue==this.cvalue){
									this.cvalueid=element.Mpid
									break;
								}
							}
						}

						this.getdistrictbycity()
					}
				});
			},
			getdistrictbycity() {
				let para={
					MpType:"SSCC",
					MpParentId:this.cvalueid
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.doptions  =res.data.data
						this.dvalue=this.doptions[0].MpValue
					}
				});
			},
			getKDPPdic() {
				let para={
					MpType:"KDPP",
					MpParentId:"179"
				}
				getparamsByType(para).then((res) => {
					if(res.data.code==0){
						this.ppoptions  =res.data.data
						this.ppvalue=this.ppoptions[0].MpValue
					}
				});
			},

			// 协议客户管理
			showGuestcompany: function (index, row) {
				this.guestcomVisible = true;
				this.curcoId=row.coId
				this.gpage=0
				this.guestCompanyList();

			},
			handlegCurrentChange(val) {				
				this.gpage = val;
				this.guestCompanyList();
			},
			//获取协议客户列表
			guestCompanyList() {
				let para = {
					page: this.gpage,
					pageSize:20,
					coId:this.curcoId,
					objectId:this.objectId,
					guestComName:this.gfilters.guestComName,
				};

				companyGuestPageList(para).then((res) => {
					if(res.data.code==0){
						this.gtotal = res.data.data.total;
						this.comguestlist = res.data.data.list;
					}
				});
			},
			handleFileShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.fileUrl
				this.pdfFileName="协议"
				this.pdfVisible=true
			},
			handleWidNoShow: function (index, row) {
				this.pdfSrc=this.filebaseurl+row.widUrl
				this.pdfFileName="证件"
				this.pdfVisible=true
			},
			//导出excel
			handledc: function() {

				this.$confirm('确认导出企业表吗？', '提示', {}).then(() => {
					let para = {
						objectId:this.objectId,
						coName: this.filters.companyName,
					};

					this.dcLoading = true;

					companyPageListdc(para).then(res => {
						this.dcLoading = false;

						if (res.data.code == 0) {
							//将data数据赋给exportList这个列表，用于当作导出Excel的数据源
							this.exportList = res.data.data;

							//开始执行导出方法，此方法要放在括号里面，因为是异步请求数据，请求完才能执行导出
							this.export2Excel();
						} 
						else {
							this.$message.error(res.data.message);
						}
					});
					
				}).catch(() => {
  					// 用户点了取消 → 必须写 catch，否则控制台报错
					// this.$message.info('已取消');
				});			
			},

			export2Excel() {
			require.ensure([], () => {
				const { export_json_to_excel } = require("@/vendor/Export2Excel");

				const tHeader = [
				"企业名称",
				"所属区",
				"品牌",
				"法人或负责人姓名",
				"法人或负责人身份证号",
				"法人或负责人电话",
				"企业联系邮箱",
				"社会信用代码",
				"经营许可证号或分支机构名录号",
				"许可证有效期",
				"企业地址",

				];

				const filterVal = [
				"coName",
				"districtName",
				"kdppTypeName",
				"coHeadName",
				"coHeadWidNo",
				"coHeadMobile",
				"coEmail",
				"socialCreditCode",
				"businessNumber",
				"businessNumberEffectDate",
				"coAddress",
				
				];

				const list = this.exportList;

				const data = this.formatJson(filterVal, list);

				export_json_to_excel(
					tHeader,
					data,
					"企业表_" + moment(new Date()).format("YYYYMMDDHHmmss")
				);
			});
			},

			formatJson(filterVal, jsonData) {
			return jsonData.map(v => filterVal.map(j => v[j]));
			},
		},
		mounted() {			
			let user = JSON.parse(sessionStorage.getItem('user'));
			this.objectId = user.data.userId

			if (user.data.roleId=="4") {
				this.filters.companyName = user.data.userName	
				this.bshow=true
				this.bquery=false
			} else {
				this.bquery=true
				this.bshow=false
			}
			//默认市局管理员创建自己城市的企业
			if (user.data.roleId=="3") 
			{
				this.cvalue= user.data.cityCode
				this.cityFix=true
			}	
			else{
				this.cityFix=false
			}
			this.getCompanyList();
			this.getprovinces();
			this.getKDPPdic();
		}
	}

</script>

<style scoped>
	

</style>


// WEBPACK FOOTER //
// enterprise.vue?6c4edecc